import { useEffect, useState } from "react";
import SimpleBackdrop from "../../components/Loading/Simplebackdrop";
import Template from "../../template/Template";
import { Box, Grid } from "@mui/material";
import TabMenu from "../../components/Tabs/TabMenu";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api, apiSpjUrl } from "../../services/api";
import { useSearchParams } from "react-router-dom";
import InputLabel from "../../components/Inputs/InputLabel";
import { EscritorioType } from "../../types/EscritorioType";
import SelectSimple from "../../components/Selects/SelectSimple";
import { arrayUf } from "../../data/dataUf";
import FormCadEscritorio from "./Dados/FormCadEscritorio";
import LicenseDashboard from "./License/LicenseDashboard";
import { LicenceType } from "../../types/LicenceType";
import Estatisticas from "./Estatisticas/Estatisticas";
import { UsuarioSysproJudType } from "../../types/UsuarioType";
import Usuarios from "./Acessos/Usuarios";

export default function InfoEscritorio() {
    const [searchParms] = useSearchParams();
    const [load, setLoad] = useState(false);
    const [info, setInfo] = useState<EscritorioType | null>(null);
    const [licence, setLicence] = useState<Partial<LicenceType> | null>(null);
    const [usuarios, setUsuarios] = useState<UsuarioSysproJudType[]>([]);

    async function loadData() {
        setLoad(true);
        try {
            const id = searchParms.get('id');
            if (id) {
                const response = await api.get(`/escritorio/${id}`);
                if (response.data) {
                    if(response.data.escritorio) setInfo(response.data.escritorio);
                    if(response.data.licence) setLicence(response.data.licence);
                    if(response.data.usuarios) setUsuarios(response.data.usuarios);
                }
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Template menuActive="Escritorios">
            <SimpleBackdrop open={load} />
            <TabMenu 
                tabs={["DADOS ESCRITORIO", "LICENÇAS", "ACESSOS"]}
                // tabs={["DADOS ESCRITORIO", "LICENÇAS", "ACESSOS", "ESTATISTICAS", "FUNÇÕES"]}
            >
                <FormCadEscritorio {...info} />
                
                <LicenseDashboard licence={licence} setLicence={setLicence} />

                <Usuarios usuarios={usuarios} />

                {/* <Estatisticas /> */}

                {/* <h1>ULTIMO LOGIN USUARIOS</h1>
                    <h1>PETIÇOES E DOCUMENTOS GERADOS</h1>
                    <h1>QUANTIDADE CLIENTES</h1>
                    <h1>QUANTIDADE PROCESSOS</h1> */}

                {/* <Box>
                    <h1>ENVIAR NOTIFICAÇÕES</h1>
                </Box> */}
            </TabMenu>
        </Template>
    );
}